import './index.scss';

const Experience =()=>{
    return (
        <div class="timeline">
            <div className='experience_block right-top'>
                <div className='test_box'>
                    <h2>ByteDance Inc.
                    </h2>
                    <smail>
                    Mar. 2021 - Aug. 2021
                    </smail>
                    <p>
                    •Developed a Django-based web application slashing manual processing time by 30%<br></br>
                    •Leveraged HiveSQL to distill key insights from large datasets<br></br>
                    •Developped application data streaming and
                    daily ETL scripts.<br></br>
                    •Conceived and developed a chatbot using Lark API for request collection.<br></br>
                    </p>
                    <span class="down_arrow">
                    </span>
                </div>
            </div>

            <div className='experience_block right-bottom'>
                <div className='test_box'>
                    <h2>Yum Inc. China
                    </h2>
                    <smail>
                    Jun. 2019 - Aug. 2019
                    </smail>
                    <p>
                    •Mastered tools like Apache Kafka, Hive <br></br>
                    •Develop an Oozie-based spark integration test framework<br></br>
                    •Develop the "SET SESSION AUTHORIZATION" SQL statement to support user
                    switching<br></br>
                    •Analyzed sales data using MySQL and R scripts<br></br>
                    </p>
                    <span class="up_arrow">
                    </span>
                </div>
            </div>

            <div className='experience_block put3'>
                <div className='test_box'>
                    <h2>Yum Inc. China
                    </h2>
                    <smail>
                    Jun. 2019 - Aug. 2019
                    </smail>
                    <p>
                    •Mastered tools like Apache Kafka, Hive <br></br>
                    •Develop an Oozie-based spark integration test framework<br></br>
                    •Develop the "SET SESSION AUTHORIZATION" SQL statement to support user
                    switching<br></br>
                    •Analyzed sales data using MySQL and R scripts<br></br>
                    </p>
                    <span class="down_arrow">
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Experience